import { ChangeDetectionStrategy, Component, Input, Output, OnInit, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { Assessor } from 'src/app/models/Assessor';
import { ShortVoter } from 'src/app/models/ShortVoter';

@Component({
  selector: 'app-assessors-track',
  templateUrl: 'assessors-track.component.html',
  styleUrls: ['./assessors-track.component.less', '../../../shared/common.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class AssessorsTrackComponent implements OnInit, OnChanges {
  @Input() isValidated: boolean = false;
  @Input() assessors: Array<Assessor> = [];
  @Input() remainingAssessors = 0;
  @Input() inactiveAssessors: ShortVoter[] = [];

  @Output() updateAssessorEvent = new EventEmitter();
  @Output() relaunchAssessorEvent = new EventEmitter();
  isExpanded: boolean = true;

  private inactiveEmails = new Set<string>();

  hasValidatedAssessorKey(assessor: Assessor): boolean {
    return !this.inactiveEmails.has(assessor.email);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['inactiveAssessors']) {
      this.inactiveEmails = new Set((this.inactiveAssessors ?? []).map(ia => ia.email));
    }
  }

  ngOnInit(): void {
  }
}
